import Splide from "@splidejs/splide";
document.addEventListener('DOMContentLoaded', function () {
    // Do stuff

    // Initialize Icons Block Slider
    var elms = document.getElementsByClassName( 'wp-block-ibb-ibb006-icons' );
    for ( var i = 0; i < elms.length; i++ ) {
        new Splide( elms[ i ] ).mount();
    }

});